import { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function Overview() {
  const [stats, setStats] = useState<any | null>(null);
  useEffect(() => { api.adminStats().then(setStats); }, []);
  if (!stats) return <p className="text-mono-white/60">Loading…</p>;
  return (
    <div>
      <h1 className="text-2xl font-semibold mb-6">Overview</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <Stat label="Total runs" value={stats.total_runs} accent="mono-green" />
        <Stat label="Runs (24h)" value={stats.runs_last_24h} accent="mono-cyan" />
        <Stat label="Avg score" value={stats.avg_score ?? '—'} accent="mono-yellow" suffix={stats.avg_score ? '/100' : ''} />
        <Stat label="Learners" value={stats.total_users} accent="mono-white" />
        <Stat label="Published scenarios" value={stats.published_scenarios} />
        <Stat label="Debriefs rendered" value={stats.total_debriefs} />
        <Stat label="Protocol regions" value={stats.protocol_regions} />
        <Stat label="Outcomes" value={(stats.outcomes || []).length} />
      </div>

      {stats.outcomes && stats.outcomes.length > 0 && (
        <div className="panel p-4 mb-6">
          <h3 className="text-mono-white/60 text-xs uppercase tracking-widest mb-3">Outcome distribution</h3>
          <div className="flex gap-3 flex-wrap">
            {stats.outcomes.map((o: any) => (
              <div key={o.outcome} className="bg-ink-800 px-3 py-2 rounded">
                <div className="text-xs text-mono-white/50 uppercase tracking-widest">{o.outcome || 'unknown'}</div>
                <div className="font-mono text-xl">{o.c}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <p className="text-mono-white/50 text-sm">
        Real-time aggregations from <code className="font-mono text-mono-cyan">scenario_runs</code>, <code className="font-mono text-mono-cyan">debriefs</code>, <code className="font-mono text-mono-cyan">feedback_taxonomy</code>.
        Drill into Runs / Users / Scenarios for detail; Analytics for failure-mode aggregations.
      </p>
    </div>
  );
}

function Stat({ label, value, accent = 'mono-white', suffix }: { label: string; value: any; accent?: string; suffix?: string }) {
  return (
    <div className="panel p-4">
      <div className="text-[10px] text-mono-white/40 uppercase tracking-widest">{label}</div>
      <div className={`text-3xl font-mono tabular-nums mt-1 text-${accent}`}>{value}{suffix && <span className="text-xs text-mono-white/40 ml-1">{suffix}</span>}</div>
    </div>
  );
}
